import { render, staticRenderFns } from "./BitRelational.vue?vue&type=template&id=315fa34c&scoped=true"
import script from "./BitRelational.vue?vue&type=script&lang=js"
export * from "./BitRelational.vue?vue&type=script&lang=js"
import style0 from "./BitRelational.vue?vue&type=style&index=0&id=315fa34c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315fa34c",
  null
  
)

export default component.exports